import axios from 'axios';
import { Url } from 'src/config';

// Configure axios defaults to always send cookies
axios.defaults.withCredentials = true;
axios.defaults.baseURL = Url;

// Request interceptor - tokens are handled via HttpOnly cookies
axios.interceptors.request.use(
  (config) => {
    // Ensure credentials (cookies) are sent with requests
    config.withCredentials = true;
    return config;
  },
  (error) => Promise.reject(error)
);
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const message = error.response?.data?.message;
      
      // Check if session was invalidated
      if (message === 'Session has been invalidated') {
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('userDetails');
        sessionStorage.removeItem('userPermission');
        
        // Redirect to login page
        window.location.href = '/';
        return Promise.reject(error);
      }
      
      // Handle other 401 errors
      sessionStorage.removeItem('accessToken');
      sessionStorage.removeItem('userDetails');
      sessionStorage.removeItem('userPermission');
      
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);
// Add response interceptor to handle authentication errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 403 permission errors
    if (error.response?.status === 403) {
      const message = error.response?.data?.message;
      const errorCode = error.response?.data?.code;
      
      // Check if it's an authentication error (expired/invalid token)
      if (message === 'A token is required for authentication...' || message === 'Unauthorized Access...') {
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('userDetails');
        sessionStorage.removeItem('userPermission');
        
        if (window.location.pathname !== '/') {
          window.location.href = '/';
        }
        return Promise.reject(error);
      }
      
      // Handle permission errors
      console.warn('Permission denied:', {
        url: error.config?.url,
        method: error.config?.method,
        code: errorCode,
        message: error.response?.data?.message
      });
      
      // Show user-friendly permission error messages
      if (errorCode === 'INSUFFICIENT_PERMISSIONS') {
        // Import toast dynamically to avoid circular dependencies
        import('react-hot-toast').then(({ default: toast }) => {
          toast.error("You don't have permission to perform this action");
        });
      } else if (errorCode === 'SUPER_ADMIN_REQUIRED') {
        import('react-hot-toast').then(({ default: toast }) => {
          toast.error("Super admin access required");
        });
      } else {
        import('react-hot-toast').then(({ default: toast }) => {
          toast.error("Access denied");
        });
      }
    }
    
    return Promise.reject(error);
  }
);

export default axios;